// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth_page__-I-Zm {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--surface-sunken);
  padding: 24px;
}

.auth_card__aaMxY {
  width: 100%;
  max-width: 420px;
  background: var(--surface);
  border: var(--hairline);
  border-radius: var(--radius-14);
  padding: 36px 32px;
  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);
}

.auth_logo__07oLC {
  font-size: var(--fs-13);
  letter-spacing: 4px;
  font-weight: var(--fw-bold);
  color: var(--accent);
  text-align: center;
  text-transform: uppercase;
  margin-bottom: 6px;
}

.auth_logoImg__1ym7I {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

.auth_title__pM51v {
  font-size: var(--fs-22);
  font-weight: var(--fw-semibold);
  color: var(--text);
  text-align: center;
  margin-bottom: 28px;
}

.auth_row__qQpYI {
  display: flex;
  gap: 14px;
}

.auth_field__1BJ7t {
  margin-bottom: 16px;
  flex: 1 1;
}

.auth_label__6E4a1 {
  display: block;
  font-size: var(--fs-11);
  letter-spacing: 1px;
  text-transform: uppercase;
  color: var(--text-muted-alt);
  margin-bottom: 6px;
}

.auth_input__dBqQO {
  width: 100%;
  background: var(--surface-sunken);
  border: var(--hairline);
  border-radius: var(--radius-8);
  padding: 11px 13px;
  color: var(--text);
  font-family: inherit;
  font-size: var(--fs-14);
  outline: none;
  transition: border-color 0.15s ease;
}

.auth_input__dBqQO:focus {
  border-color: var(--accent);
}

.auth_input__dBqQO::placeholder {
  color: var(--text-faint);
}

.auth_button__vuonS {
  width: 100%;
  margin-top: 8px;
  background: var(--accent);
  color: var(--surface-high);
  border: none;
  border-radius: var(--radius-8);
  padding: 12px;
  font-family: inherit;
  font-size: var(--fs-14);
  font-weight: var(--fw-semibold);
  letter-spacing: 0.5px;
  cursor: pointer;
  transition: opacity 0.15s ease;
}

.auth_button__vuonS:hover {
  opacity: 0.9;
}

.auth_button__vuonS:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.auth_error__HXtc2 {
  background: rgba(160, 30, 30, 0.13);
  border: 1px solid rgba(224, 48, 48, 0.4);
  color: #ff9999;
  border-radius: var(--radius-8);
  padding: 10px 12px;
  font-size: var(--fs-13);
  margin-bottom: 16px;
  text-align: center;
}

/* Informational notice (e.g. expired session) — same box, amber palette. */
.auth_notice__yVXm9 {
  background: rgba(201, 149, 106, 0.13);
  border: 1px solid rgba(201, 149, 106, 0.4);
  color: var(--accent);
  border-radius: var(--radius-8);
  padding: 10px 12px;
  font-size: var(--fs-13);
  margin-bottom: 16px;
  text-align: center;
}

.auth_footer__-cfIn {
  margin-top: 22px;
  text-align: center;
  font-size: var(--fs-13);
  color: var(--text-muted-alt);
}

.auth_link__QF7i8 {
  color: var(--accent);
  text-decoration: none;
  font-weight: var(--fw-semibold);
  margin-left: 6px;
}

.auth_link__QF7i8:hover {
  text-decoration: underline;
}

/* ── Light mode variant (applied to .card via the \`light\` prop) ─────────────── */
.auth_lightCard__4oDZj {
  background: var(--surface-light-background);
  border-color: var(--border-light);
  box-shadow: 0 24px 60px rgba(120, 100, 80, 0.12);
}

.auth_lightCard__4oDZj .auth_logo__07oLC  { color: var(--accent-strong); }
.auth_lightCard__4oDZj .auth_title__pM51v { color: var(--text-on-light); }
.auth_lightCard__4oDZj .auth_label__6E4a1 { color: var(--text-muted-on-light); }

.auth_lightCard__4oDZj .auth_input__dBqQO {
  background: var(--surface-light-alt);
  border-color: var(--border-light);
  color: var(--text-on-light);
}
.auth_lightCard__4oDZj .auth_input__dBqQO:focus { border-color: var(--accent-strong); }
.auth_lightCard__4oDZj .auth_input__dBqQO::placeholder { color: #c4b4a4; }

.auth_lightCard__4oDZj .auth_button__vuonS { background: var(--accent-strong); color: var(--surface-light-alt); }
`, "",{"version":3,"sources":["webpack://./src/styles/auth.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,0BAA0B;EAC1B,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAO;AACT;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iCAAiC;EACjC,uBAAuB;EACvB,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,uBAAuB;EACvB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,0BAA0B;EAC1B,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,oBAAoB;EACpB,uBAAuB;EACvB,+BAA+B;EAC/B,qBAAqB;EACrB,eAAe;EACf,8BAA8B;AAChC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,wCAAwC;EACxC,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA,2EAA2E;AAC3E;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,kFAAkF;AAClF;EACE,2CAA2C;EAC3C,iCAAiC;EACjC,gDAAgD;AAClD;;AAEA,4CAAoB,2BAA2B,EAAE;AACjD,4CAAoB,2BAA2B,EAAE;AACjD,4CAAoB,iCAAiC,EAAE;;AAEvD;EACE,oCAAoC;EACpC,iCAAiC;EACjC,2BAA2B;AAC7B;AACA,kDAA0B,kCAAkC,EAAE;AAC9D,yDAAiC,cAAc,EAAE;;AAEjD,6CAAqB,gCAAgC,EAAE,+BAA+B,EAAE","sourcesContent":[".page {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--surface-sunken);\n  padding: 24px;\n}\n\n.card {\n  width: 100%;\n  max-width: 420px;\n  background: var(--surface);\n  border: var(--hairline);\n  border-radius: var(--radius-14);\n  padding: 36px 32px;\n  box-shadow: 0 24px 60px rgba(0, 0, 0, 0.45);\n}\n\n.logo {\n  font-size: var(--fs-13);\n  letter-spacing: 4px;\n  font-weight: var(--fw-bold);\n  color: var(--accent);\n  text-align: center;\n  text-transform: uppercase;\n  margin-bottom: 6px;\n}\n\n.logoImg {\n  width: 45px;\n  height: 45px;\n  object-fit: contain;\n}\n\n.title {\n  font-size: var(--fs-22);\n  font-weight: var(--fw-semibold);\n  color: var(--text);\n  text-align: center;\n  margin-bottom: 28px;\n}\n\n.row {\n  display: flex;\n  gap: 14px;\n}\n\n.field {\n  margin-bottom: 16px;\n  flex: 1;\n}\n\n.label {\n  display: block;\n  font-size: var(--fs-11);\n  letter-spacing: 1px;\n  text-transform: uppercase;\n  color: var(--text-muted-alt);\n  margin-bottom: 6px;\n}\n\n.input {\n  width: 100%;\n  background: var(--surface-sunken);\n  border: var(--hairline);\n  border-radius: var(--radius-8);\n  padding: 11px 13px;\n  color: var(--text);\n  font-family: inherit;\n  font-size: var(--fs-14);\n  outline: none;\n  transition: border-color 0.15s ease;\n}\n\n.input:focus {\n  border-color: var(--accent);\n}\n\n.input::placeholder {\n  color: var(--text-faint);\n}\n\n.button {\n  width: 100%;\n  margin-top: 8px;\n  background: var(--accent);\n  color: var(--surface-high);\n  border: none;\n  border-radius: var(--radius-8);\n  padding: 12px;\n  font-family: inherit;\n  font-size: var(--fs-14);\n  font-weight: var(--fw-semibold);\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  transition: opacity 0.15s ease;\n}\n\n.button:hover {\n  opacity: 0.9;\n}\n\n.button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.error {\n  background: rgba(160, 30, 30, 0.13);\n  border: 1px solid rgba(224, 48, 48, 0.4);\n  color: #ff9999;\n  border-radius: var(--radius-8);\n  padding: 10px 12px;\n  font-size: var(--fs-13);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n/* Informational notice (e.g. expired session) — same box, amber palette. */\n.notice {\n  background: rgba(201, 149, 106, 0.13);\n  border: 1px solid rgba(201, 149, 106, 0.4);\n  color: var(--accent);\n  border-radius: var(--radius-8);\n  padding: 10px 12px;\n  font-size: var(--fs-13);\n  margin-bottom: 16px;\n  text-align: center;\n}\n\n.footer {\n  margin-top: 22px;\n  text-align: center;\n  font-size: var(--fs-13);\n  color: var(--text-muted-alt);\n}\n\n.link {\n  color: var(--accent);\n  text-decoration: none;\n  font-weight: var(--fw-semibold);\n  margin-left: 6px;\n}\n\n.link:hover {\n  text-decoration: underline;\n}\n\n/* ── Light mode variant (applied to .card via the `light` prop) ─────────────── */\n.lightCard {\n  background: var(--surface-light-background);\n  border-color: var(--border-light);\n  box-shadow: 0 24px 60px rgba(120, 100, 80, 0.12);\n}\n\n.lightCard .logo  { color: var(--accent-strong); }\n.lightCard .title { color: var(--text-on-light); }\n.lightCard .label { color: var(--text-muted-on-light); }\n\n.lightCard .input {\n  background: var(--surface-light-alt);\n  border-color: var(--border-light);\n  color: var(--text-on-light);\n}\n.lightCard .input:focus { border-color: var(--accent-strong); }\n.lightCard .input::placeholder { color: #c4b4a4; }\n\n.lightCard .button { background: var(--accent-strong); color: var(--surface-light-alt); }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `auth_page__-I-Zm`,
	"card": `auth_card__aaMxY`,
	"logo": `auth_logo__07oLC`,
	"logoImg": `auth_logoImg__1ym7I`,
	"title": `auth_title__pM51v`,
	"row": `auth_row__qQpYI`,
	"field": `auth_field__1BJ7t`,
	"label": `auth_label__6E4a1`,
	"input": `auth_input__dBqQO`,
	"button": `auth_button__vuonS`,
	"error": `auth_error__HXtc2`,
	"notice": `auth_notice__yVXm9`,
	"footer": `auth_footer__-cfIn`,
	"link": `auth_link__QF7i8`,
	"lightCard": `auth_lightCard__4oDZj`
};
export default ___CSS_LOADER_EXPORT___;
